'use client';

import { useEffect } from 'react';
import { CONTENTS_AREA_ELEMENT_ID } from '~/components';

export const withBodyScrollLock = <Props extends object>(Component: React.ComponentType<Props>) =>
  function WrappedComponent(props: Props) {
    useEffect(() => {
      const contentsArea = document.getElementById(CONTENTS_AREA_ELEMENT_ID) || document.body;
      contentsArea.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      return () => {
        contentsArea.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow');
      };
    }, []);
    return <Component {...props} />;
  };
